import type { Course, OldCourse, School } from '../../types';

import styles from './course-list.module.css';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function courseMonth(date: string | undefined): string {
  if (!date) return '';

  return date
    .split(',')
    .filter((s) => parseInt(s) >= 1 && parseInt(s) <= 12)
    .map((s) => months[parseInt(s) - 1])
    .join(', ');
}

type Props = {
  courses: School['courses'];
};

function isCurrentCourse(course: Course | OldCourse): course is Course {
  return !('L' in course);
}

export function CourseList(props: Props) {
  const { courses } = props;

  if (!courses) {
    return null;
  }

  // !('L' in course) &&  - old legacy courses have that weird structure and is unused now

  return (
    <div className={styles.root}>
      {courses.map((course, i) => (
        <div className={styles.listItem} key={i}>
          {isCurrentCourse(course) && course.type === 'normal' && (
            <>
              <h3 className={styles.title}>{course.course}</h3>
              <div className={styles.overflow}>
                <table className={styles.table}>
                  <tbody>
                    <tr>
                      <th>Hours</th>
                      <th colSpan={2}>Fees</th>
                      <th>Length</th>
                      <th>Admission month</th>
                      <th>Purpose</th>
                      <th className={styles.tdCenter}>Weeks</th>
                    </tr>
                    <tr>
                      <td>{course.classHours}</td>
                      <td>
                        <ul>
                          <li>Tuition:</li>
                          <li>Admission:</li>
                          <li>Selection:</li>
                          <li>Other:</li>
                          <li>Total:</li>
                        </ul>
                      </td>
                      <td>
                        <ul>
                          <li className={styles.tdRight}>&#165;{course.feeTuition}</li>
                          <li className={styles.tdRight}>&#165;{course.feeAdmission}</li>
                          <li className={styles.tdRight}>&#165;{course.feeSelection}</li>
                          <li className={styles.tdRight}>&#165;{course.feeOther}</li>
                          <li className={styles.tdRight}>&#165;{course.feeTotal}</li>
                        </ul>
                      </td>
                      <td>{course.length}</td>
                      <td>{courseMonth(course.monthOfAdmission)}</td>
                      <td>{course.purpose}</td>
                      <td className={styles.tdCenter}>{course.weeks}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
          {isCurrentCourse(course) && course.type === 'extended' && (
            <>
              <h3 className={styles.title}>{course.course}</h3>
              <div className={styles.overflow}>
                <table className={styles.table}>
                  <tbody>
                    <tr>
                      <th>Year</th>
                      <th>Screening fee</th>
                      <th>Admission fee</th>
                      <th>Tuition</th>
                      <th>Other Fees</th>
                      <th>Materials Fees</th>
                      <th>Subtotal</th>
                      <th>Total</th>
                    </tr>
                    {course.years.map((year) => (
                      <tr key={year.year}>
                        <td>{year.year}</td>
                        <td>{year.screeningFee}</td>
                        <td>{year.admissionFee}</td>
                        <td>{year.tuition}</td>
                        <td>{year.otherFees}</td>
                        <td>{year.materialsFee}</td>
                        <td>{year.subtotal}</td>
                        <td>{year.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {isCurrentCourse(course) && course.type === 'tuition' && (
            <>
              <h3 className={styles.title}>{course.course}</h3>
              <div className={styles.overflow}>
                <table className={styles.table}>
                  <tbody>
                    <tr>
                      <th>Duration</th>
                      <th>Tuition Fee</th>
                    </tr>
                    {course.years.map((year) => (
                      <tr key={year.year}>
                        <td>{year.year}</td>
                        <td>{year.tuition}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {isCurrentCourse(course) && course.type === 'other' && (
            <>
              <h3 className={styles.title}>
                <span>Other</span>
              </h3>
              <div className={styles.value}>{course.course}</div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
